<template>
  <div>
    <Header />

    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
    </div>

    <div class="home-static dark-overlay">
      <div class="header-inner">
        <div class="header-table">
          <div class="col-md-offset-2 col-md-8">
            <h2>We all are working together.</h2>
            <p>We are top class developer house. <br>
              People come to us for building beautiful responsive websites. <br>
              We love to work with it.</p>
          </div>
        </div>
      </div>
    </div>

    <section class="about-area section-padding" id="about">
      <div class="container">
        <div class="row">
          <div class="col-md-5 col-sm-12 col-xs-12">
            <div class="about-img">
              <img class="img-responsive" src="../assets/history-home.jpg" alt="" />
            </div>
          </div>
          <div class="col-md-7 col-sm-12 col-xs-12">
            <div class="about-content">
              <div class="section-title">
                <h2>Marvel History</h2>
                <p>Passionate, we created in 2011 an innovative agency to bring our experience and revolutionize the web.</p>
                <p>Every day we face technical challenges that optimize the digital presence of our customers.</p>
                <p>... we love it!</p>
              </div>
              <p></p>
              <p></p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<script>
import Header from './Header'
import Footer from './Footer'

export default {
  name: 'Home',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      loading: true
    }
  },
  created () {
    this.loading = false
  }
}
</script>

<style type="text/css" scoped>
.home-static {
  background: url(../assets/background-home.jpg) no-repeat fixed;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue